import PropTypes from 'prop-types';

export const PersonalizedSearchEntities = {
  dealership: PropTypes.shape({
    details: PropTypes.shape({
      address: PropTypes.shape({
        street: PropTypes.string,
        city: PropTypes.string,
        state_code: PropTypes.string,
        zip_code: PropTypes.string,
      }),
      reviews: PropTypes.shape({
        count: PropTypes.number,
        simple: PropTypes.number,
      }),
      distance_fmt: PropTypes.string,
      location_id: PropTypes.number,
    }),
    name: PropTypes.string,
    url: PropTypes.string,
    type: PropTypes.string,
  }),
};
